import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpJobOrderGenDocLinkContainerModel } from '../../../../../../models/aggregates/mrp-prodsys/mrp-job-order-gendoc-link-container.model';


@Injectable({
  providedIn: 'root'
})
export class MrpJobOrderGenDocLinkService extends BaseApiTemplateService<MrpJobOrderGenDocLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-order-gen-doc-link/backoffice-ep"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-order-gen-doc-link/backoffice-ep"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-order-gen-doc-link/backoffice-ep"
    this.httpClient = http;
  }

}
